module.exports = __webpack_public_path__ + "img/delete.85da0d15.svg";